import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { IGetState, TCardId } from '../../../../../../../../types/types';
import { SegmentCardSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onClick = (
    source: SegmentCardSourceValue,
    cardId: TCardId,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_DROPDOWN_BUTTON_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: source
        }));
    };
};
